import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { TextFieldWithAddon } from '../../../ui/FormElement';

function AnnualDiscount(props) {
  const { typeView, isDisabled, ...rest } = props;

  const {
    values: { payment_mode },
    setFieldValue,
  } = useFormikContext();

  return (
    <TextFieldWithAddon
      disabled={(typeView == 'policy' && !payment_mode) || isDisabled}
      name="annual_discount"
      type="number"
      addon="%"
      min="0"
      step="0.01"
      pattern="d+(.d{1,2})?"
      {...rest}
    />
  );
}

export default AnnualDiscount;
